import React from 'react'
import Link from 'next/link'
import {
  ActionSection,
  ActionEyebrow,
  ActionHeading,
  ActionCopy,
  ActionLinks,
  ActionLink,
} from './action-panel.styles'
import { analyticsModuleAttributes } from '../../lib/analytics-content.mjs'

export function ActionPanel({ data }) {
  return (
    <ActionSection {...analyticsModuleAttributes(data, 'action_panel', undefined, data.header)}>
      {data.eyebrow && <ActionEyebrow>{data.eyebrow}</ActionEyebrow>}
      <ActionHeading>{data.header}</ActionHeading>
      {data.text && <ActionCopy>{data.text}</ActionCopy>}
      <ActionLinks>
        {data.actions?.map((action, index) => {
          const isInternal = action.url.startsWith('/')
          return (
            <ActionLink
              as={isInternal ? Link : 'a'}
              key={action._key || action.url}
              href={action.url}
              {...(!isInternal
                ? { target: '_blank', rel: 'noopener noreferrer' }
                : {})}
              $primary={index === 0}
              data-analytics-cta-id={action._key || `action-${index}`}
              data-analytics-cta-type={isInternal ? 'internal_navigation' : 'website'}
              data-analytics-cta-label={action.label}
              data-analytics-placement-id="action-panel"
            >
              {action.label}
              <span aria-hidden="true">{isInternal ? '→' : '↗'}</span>
            </ActionLink>
          )
        })}
      </ActionLinks>
    </ActionSection>
  )
}

export default ActionPanel
